import Vue from 'vue';
import Component from 'vue-class-component';
import JhiHibar from './core/jhi-hibar/jhi-hibar.vue';
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';
import LoginForm from '@/account/login-form/login-form.vue';
import CoopbaTopbar from '@/core/coopba-topbar/coopba-topbar.vue';

import '@/shared/config/dayjs';

@Component({
  components: {
    /*  ribbon: Ribbon, */
    'jhi-hibar': JhiHibar,
    'jhi-navbar': JhiNavbar,
    'login-form': LoginForm,
    'jhi-footer': JhiFooter,
    'coopba-topbar': CoopbaTopbar,
  },
})
export default class App extends Vue {
  public get fullBleed(): boolean {
    return !!this.$route.meta?.fullBleed;
  }
}
